// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_session_tree from "./web_session_tree.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";

function rows(m) {
  return Mapre_web__Web_session_tree.rows(m.session_query, m.collapsed_sessions, Mapre_web__Web_types.session(m.route), m.sessions);
}

function label(source) {
  const partial_arg = "circle_dot";
  const partial_arg$1 = {
    hd: [
      "aria-hidden",
      "true"
    ],
    tl: /* [] */ 0
  };
  const partial_arg$2 = "session-indicator";
  const partial_arg$3 = 8;
  const partial_arg$4 = 8;
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = "hidden";
      const partial_arg$1 = "ellipsis";
      const partial_arg$2 = "nowrap";
      const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (r) {
        return r.session.title;
      }), source)));
      const partial_arg$4 = "session-title";
      const partial_arg$5 = 0;
      const partial_arg$6 = 1;
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.icon(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$6 = 0;
  const partial_arg$7 = "center";
  const partial_arg$8 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$8, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (r) {
          return Mapre_web__Web_types.status(r.session.status);
        }), source)));
        const partial_arg$1 = "muted session-status";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$9 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$10 = 0;
  const partial_arg$11 = 1;
  const partial_arg$12 = 3;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$12, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, param, param$1);
  };
}

function view(source, send, w, p) {
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___005_) {
      const partial_arg = Signal.map(rows, source);
      const partial_arg_0 = function (param, param$1) {
        return Lui_elements.keyed(partial_arg, (function (r) {
          return r.session.id;
        }), Stdlib__String.compare, (function (param) {
          const first = Signal.sample(param);
          const partial_arg = Signal.map((function (r) {
            return r.branch;
          }), param);
          const partial_arg_0 = function (param$1, param$2) {
            return Lui_elements.dyn(undefined, (function (branch) {
              const widget = function (expanded_signal, on_toggle, children) {
                return function (param$3, param$4) {
                  return Lui_elements.scoped((function (__lui_context___003_) {
                    const partial_arg = {
                      TAG: /* Navigate */ 0,
                      _0: {
                        TAG: /* Session */ 3,
                        _0: w,
                        _1: p,
                        _2: first.session.id
                      }
                    };
                    const partial_arg$1 = (function (param) {
                      return Lui_elements.press(send, partial_arg, param);
                    });
                    const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (r) {
                      return r.selected;
                    }), param)));
                    const partial_arg$3 = first.level;
                    const partial_arg$4 = "treeitem";
                    const partial_arg$5 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (r) {
                      if (r.branch) {
                        if (r.expanded) {
                          return {
                            NAME: "app",
                            VAL: "chevron-down"
                          };
                        } else {
                          return {
                            NAME: "app",
                            VAL: "chevron-right"
                          };
                        }
                      } else {
                        return {
                          NAME: "app",
                          VAL: "circle-dot"
                        };
                      }
                    }), param)));
                    const partial_arg$6 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (r) {
                      return {
                        hd: [
                          "data-session-id",
                          r.session.id
                        ],
                        tl: {
                          hd: [
                            "data-session-status",
                            r.session.status
                          ],
                          tl: /* [] */ 0
                        }
                      };
                    }), param)));
                    const partial_arg$7 = "session-tree-item";
                    const partial_arg$8 = 56;
                    const partial_arg$9 = 0;
                    const partial_arg$10 = 8;
                    return function (param, param$1) {
                      return Lui_elements.list_item(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, partial_arg$3, undefined, expanded_signal, undefined, partial_arg$2, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, on_toggle, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, children, param, param$1);
                    };
                  }), param$3, param$4);
                };
              };
              if (branch) {
                return function (param$3, param$4) {
                  return Lui_elements.scoped((function (__lui_context___004_) {
                    return widget(Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (r) {
                      return r.expanded;
                    }), param))), (function (param) {
                      if (param.TAG !== /* ToggleChanged */ 4) {
                        return;
                      }
                      Curry._1(send, {
                        TAG: /* Expand_session */ 28,
                        _0: first.session.id,
                        _1: param._1
                      });
                    }), {
                      hd: label(param),
                      tl: /* [] */ 0
                    });
                  }), param$3, param$4);
                };
              } else {
                return widget(undefined, undefined, {
                  hd: label(param),
                  tl: /* [] */ 0
                });
              }
            }), partial_arg, param$1, param$2);
          };
          const partial_arg$1 = {
            hd: partial_arg_0,
            tl: /* [] */ 0
          };
          const partial_arg$2 = 0;
          const partial_arg$3 = ((first.level - 1 | 0) << 4);
          return function (param, param$1) {
            return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
          };
        }), param, param$1);
      };
      const partial_arg$1 = {
        hd: partial_arg_0,
        tl: /* [] */ 0
      };
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
        return {
          hd: [
            "data-chat-list",
            "sessions"
          ],
          tl: {
            hd: [
              "data-row-count",
              String(Stdlib__List.length(rows(m)))
            ],
            tl: /* [] */ 0
          }
        };
      }), source)));
      const partial_arg$3 = 0;
      const partial_arg$4 = 1;
      const partial_arg$5 = 2;
      const partial_arg$6 = 64;
      const partial_arg$7 = 5;
      return function (param, param$1) {
        return Lui_elements.virtual_list(undefined, partial_arg$7, partial_arg$6, partial_arg$5, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg = {
    hd: partial_arg_0,
    tl: /* [] */ 0
  };
  const partial_arg$1 = "Sessions";
  const partial_arg$2 = 0;
  const partial_arg$3 = 0;
  const partial_arg$4 = 1;
  return function (param, param$1) {
    return Lui_elements.tree(undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
